// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.piped-response-value{display:inline-flex;justify-content:start;align-items:center;gap:0.5rem;font-size:0.75rem;color:var(--s-d-110);line-height:1.25rem;padding:0 0.375rem;background-color:var(--s-5);border:0.0625rem solid var(--s-30);border-radius:0.25rem}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
